import { useState } from 'react';
import { Link } from 'react-router-dom';

import logo from '@/assets/logo.svg';
import logoTitle from '@/assets/logo_title.svg';
import { useAppSetting } from '@/store/appSetting';
import Typography from '../typography';
import WelcomeModal from './welcomeModal';
import { Connect } from './connect';
import { Routes } from './routes';
import { Testtip } from './testtip';
import { Books } from './books';

const Navbar = (): JSX.Element => {
  const { auth } = useAppSetting();
  const [showWelcome, setShowWelcome] = useState(true);

  return (
    <>
      {import.meta.env.MODE !== 'prod' ? <Testtip /> : null}
      <div className="navbar flex h-[90px] w-[100vw] items-center justify-between px-[32px] lg:px-[100px]">
        <Link to="/home">
          <div className="invisible flex sm:visible">
            <img className="h-[28px] w-[38px]" src={logo} alt="logo" />
            <img
              className="ml-[12px] h-[28px] w-[69px]"
              src={logoTitle}
              alt="logo title"
            />
            {import.meta.env.MODE === 'testnet' ? (
              <Typography
                variant="subTitle"
                className="ml-[14px] leading-[28px]"
              >
                TestNet: Mumbai
              </Typography>
            ) : import.meta.env.MODE === 'test' ? (
              <Typography
                variant="subTitle"
                className="ml-[14px] leading-[28px]"
              >
                Development: Mumbai
              </Typography>
            ) : (
              ''
            )}
          </div>
        </Link>
        <div className="flex items-center text-[18px] font-[400] leading-[32px] text-[#4E4E4E]">
          <Routes />
          <Books />
          <Connect />
        </div>
        {auth.token && showWelcome && !auth.popup ? (
          <WelcomeModal
            num={auth.number}
            onClose={() => setShowWelcome(false)}
          />
        ) : null}
      </div>
    </>
  );
};

export default Navbar;
